/**
 * Application Route Constants
 * Centralized route paths for consistent navigation
 */

export const ROUTES = {
  // Authentication
  LOGIN: "/login",
  SECONDARY_LOGIN: "/secondary-login",

  // Main Application
  AUDIT_LOG: "/audit-log",
  DOOR_SCHEDULE: "/doorSchedule",
  PROJECT_DETAILS: "/doorSchedule/:pId",
  FILE_LISTING: "/doorSchedule/:projectId/:selectedFile",

  // Maintenance
  MAINTENANCE: "/maintenance",

  // Root
  ROOT: "/",
};

/**
 * Helper function to generate dynamic routes
 * @param {string} route - Route template
 * @param {Object} params - Parameters to replace
 * @returns {string} - Generated route
 */
export const generateRoute = (route, params = {}) => {
  let generatedRoute = route;

  Object.entries(params).forEach(([key, value]) => {
    generatedRoute = generatedRoute.replace(`:${key}`, value);
  });

  return generatedRoute;
};

// Usage examples:
// generateRoute(ROUTES.PROJECT_DETAILS, { pId: '123' }) => '/doorSchedule/123'
// generateRoute(ROUTES.FILE_LISTING, { projectId: '123', selectedFile: 'file.xlsx' })
